import { AppState, AppStateActionParams } from 'records/AppState';
import { getLicense } from 'services/licensingService';

export interface LicensingActions {
  getAndSetLicense: (actionParams: AppStateActionParams) => Promise<AppState>;
}

const licensingActions = {
  getAndSetLicense: async ({
    state,
  }: AppStateActionParams): Promise<AppState> => {
    const license = await getLicense();

    return state().set('userLicense', license);
  },
};

export default licensingActions;
